import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/home/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { keepAlive: true },
  },
  {
    path: "/basicFacts",
    name: "basicFacts",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/basicFacts.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/news",
    name: "News",
    component: () => import("@/views/news.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/imgs",
    name: "Imgs",
    component: () => import("@/views/imgs.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/product",
    name: "Product",
    component: () => import("@/views/product.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/views/notice.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/contactUs",
    name: "ContactUs",
    component: () => import("@/views/contactUs.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/dynamic",
    name: "dynamic",
    component: () => import("@/views/dynamic.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/newsDetail",
    name: "NewsDetail",
    component: () => import("@/views/newsDetail.vue"),
  },
  {
    path: "/productDetail",
    name: "ProductDetail",
    component: () => import("@/views/productDetail.vue"),
  },
  {
    path: "/data",
    name: "data",
    component: () => import("@/views/data.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/rule",
    name: "rule",
    component: () => import("@/views/rule.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/party",
    name: "party",
    component: () => import("@/views/party.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/market",
    name: "market",
    component: () => import("@/views/market.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/work",
    name: "work",
    component: () => import("@/views/work.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/down",
    name: "down",
    component: () => import("@/views/down.vue"),
    meta: { keepAlive: true },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search.vue"),
  },
  {
    path: "/searchDetail",
    name: "searchDetail",
    component: () => import("@/views/searchDetail.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
